import type { BenefitWorkflowResponse } from "./benefit-types"

/** Explain existing authority, never infer or grant an editing capability. */
export function householdEditDisabledReason({ current, refreshUnavailable, workflow, canEdit, section = "Household" }: {
  current: boolean
  refreshUnavailable: boolean
  workflow: BenefitWorkflowResponse | null
  canEdit: boolean
  /** The server capability that actually gates this card; the questionnaire also needs Program. */
  section?: string
}): string | null {
  if (refreshUnavailable) return "Saved application information could not be refreshed. Use Retry refresh before editing."
  if (!current) return "Refreshing saved application information. Editing will be available once the refresh finishes and permissions are checked."
  if (!workflow || !["Legacy", "V2"].includes(workflow.authority)) return "Editing permissions could not be verified. Refresh the application and try again."
  if (canEdit) return null
  if (workflow.authority === "Legacy") {
    return workflow.legacyProofingStatus === 10
      ? "Your permissions do not allow editing completed applications."
      : "This application's status does not allow household edits."
  }
  const capability = workflow.sections.find(row => row.section === section)
  if (!capability) return `The server did not provide ${section.toLowerCase()} editing permissions. Refresh the application and try again.`
  const reason = capability.explanation?.trim() || "Your role or this application's state does not allow these edits."
  // The server may report a role, rollout or financial restriction, not just a locked state.
  // State is context, not an invented diagnosis that replaces that explanation.
  return workflow.state ? `Application state: ${workflow.state}. ${reason}` : reason
}
